<template>
  <v-layout row justify-center>
    <v-dialog 
      content-class="giftConfigDialog"
      v-model="consentTermTextEditDialog"
      persistent 
      max-width="75%"
      max-height="90%"
    >
    <v-card>
      <v-card-title class="headline">
        <h1>Meios de Pagamento - TERMOS DE CONSENTIMENTO</h1>
        <v-btn class="close-modal" @click="$emit('closeConsentTermTextEditDialog')">
          <i class="fal fa-times"></i>
        </v-btn>
      </v-card-title>
      <v-card-text style=" padding:20px; justify-content: center; overflow: auto; max-height: 80vh;">
          <v-layout style="padding: 20px; font-size: 24px; font-weight: 600" column gap-xl ml-3 mt-3>
            <label v-if="!currentCampaignId" style="font-size: 14px; text-align: left;">
              Salve a campanha antes de editar os termos de consentimento.
            </label>
            <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
            <v-list class="p-5" v-if="currentCampaignId && !loading">
              <v-list-group
                v-for="paymentMethod in paymentMethods" :key="paymentMethod.id"
                class="mb-5"
            >
              <template v-slot:activator>
                <v-list-tile-content class="mt-3">
                  <v-list-tile-title
                  >{{ paymentMethod.name }}</v-list-tile-title>
                </v-list-tile-content>
              </template>
                <div class="t-area-heart-step mt-2 mb-3">
                  <label>Digite o texto do termo de consentimento para <strong> {{ paymentMethod.name }}</strong></label>
                  <vue-editor
                    v-model="texts[paymentMethod.id]"
                    :editor-toolbar="customToolbar"
                  />
                </div>
            </v-list-group>
            </v-list>
            <label style="font-size: 14px; text-align: left;">Obs: Se um meio de pagamento não tiver um termo de consentimento personalizado, ele usará o <strong>termo de consentimento padrão</strong>.</label>
          </v-layout>
          
      </v-card-text>
      <v-card-actions class="pa-0">
          <div class="footer-modal-atividades">
            <v-btn
        flat
        round
        color="white"
        class="btn btn-primary px-5"
        large
        :loading="saving"
        :disabled="!currentCampaignId || loading"
        @click="save"
      >Salvar</v-btn>
      <v-btn
        flat
        round
        color="white"
        class="btn btn-default px-5"
        large
        @click="$emit('closeConsentTermTextEditDialog')"
      >Fechar</v-btn>
          </div>
      </v-card-actions>
      
    </v-card>
    </v-dialog>
  </v-layout>
</template>

<script type="plain/text">
// Services
import CampaignService from "@/scripts/services/campaign.service.js";

// Editor
import { VueEditor } from "vue2-editor";

export default {
  props: {
    consentTermTextEditDialog: Boolean,
    // Campanha em edicao -- nao a do subdominio (campaignLandingPageConfig), que pode ser outra.
    campaignId: [Number, String],
  },
  components: {
    VueEditor,
  },
  data() {
    return {
      campaignService: new CampaignService(),
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
      paymentMethods: [],
      texts: {},
      originalTexts: {},
      loading: false,
      saving: false,
    };
  },
  computed: {
    currentCampaignId() {
      return Number(this.campaignId) || 0;
    },
  },
  created() {
    this.campaignService.listAllPaymentMethod((response) => {
      this.paymentMethods = response || [];
      this.fillTexts(this.originalTexts);
    });
  },
  watch: {
    consentTermTextEditDialog(open) {
      if (open) this.load();
    },
    campaignId() {
      if (this.consentTermTextEditDialog) this.load();
    },
  },
  methods: {
    fillTexts(loaded) {
      const texts = {};
      this.paymentMethods.forEach((pm) => {
        texts[pm.id] = loaded[pm.id] || "";
      });
      this.texts = texts;
      this.originalTexts = { ...texts };
    },
    load() {
      if (!this.currentCampaignId) {
        this.fillTexts({});
        return;
      }
      this.loading = true;
      this.campaignService
        .ListAllPaymentMethodConsentTermsByCampaignId(this.currentCampaignId)
        .then((terms) => {
          // A API devolve o mais recente primeiro; fica o primeiro de cada meio de pagamento.
          const loaded = {};
          (terms || []).forEach((term) => {
            if (!(term.paymentMethodId in loaded)) loaded[term.paymentMethodId] = term.paymentMethodConsentTermText || "";
          });
          this.fillTexts(loaded);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save() {
      if (!this.currentCampaignId) return;
      const changed = Object.keys(this.texts)
        .filter((pmId) => (this.texts[pmId] || "") !== (this.originalTexts[pmId] || ""))
        .map((pmId) => ({
          campaignId: this.currentCampaignId,
          paymentMethodId: Number(pmId),
          paymentMethodConsentTermText: this.texts[pmId] || "",
          active: true,
        }));

      if (!changed.length) {
        this.$store.commit("SET_SNACKBAR_MESSAGE", "Nenhum termo foi alterado.");
        return;
      }

      this.saving = true;
      this.campaignService
        .savePaymentMethodConsentTerms(changed)
        .then(() => {
          this.originalTexts = { ...this.texts };
          this.$store.commit("SET_SNACKBAR_SUCCESS_MESSAGE", "Termo de anuência alterado com sucesso!");
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>